import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { tap } from 'rxjs';
import { config } from 'src/app/config/api.config';
import { ProgrammeCoursera } from 'src/app/model/programme-coursera';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { environment } from 'src/environments/environments';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  email!: string;
  fullname!: string;
  user: any;
  profil: any;
  eleve: boolean = false;
  role!: any[];
  isFcc: boolean = false;
  isAdmin: boolean = false;
  isBoard: boolean = false;
  isSEV: boolean = false;
  isStemd: boolean = false;
  cohorte: string = '';
  parcours3: string = 'SIG2412-FODE';
  parcours4: string = 'SIG2502-FODE';
  isStudentStemd: boolean = false;
  isMentor: boolean = false;
  isChefEtab: boolean = false;
  isFinance: boolean = false;
  isAipen: boolean = false;
  isAdminFcc: boolean = false;
  coursera_user: boolean = false;
  iuf: string = sessionStorage.getItem('iuf') || '';
  nomrole!: string;
  isMAE: boolean = false;

  showMenu: boolean = false;
  plateformeLMSService: any;

  constructor(
    private router: Router,
    private keycloak: KeycloakService,
    private backapi: BackendApiService,
  ) { }

  ngOnInit() {
    this.keycloak.isLoggedIn().then(async (value) => {
      if (value) {
        this.backapi
          .getBeneficiaryByEmail((await this.keycloak.loadUserProfile()).email)
          .pipe()
          .subscribe({
            next: (response) => {
              sessionStorage.setItem('user', JSON.stringify(response));
              sessionStorage.setItem('logged', 'true');

              this.user = sessionStorage.getItem('user');
              this.profil = JSON.parse(this.user).profile.id;
              this.email = JSON.parse(this.user).email;
              sessionStorage.setItem('iuf', JSON.parse(this.user).iuf);
              // console.log('user : ', JSON.parse(this.user));
              this.isMAE = this.checkIsMae(JSON.parse(this.user).offTrackList);

              this.fullname =
                JSON.parse(this.user).lastname +
                ' ' +
                JSON.parse(this.user).firstname;
              this.profil = JSON.parse(this.user).profile.id;
              this.role = JSON.parse(this.user)?.roles;
              if (
                JSON.parse(this.user)?.roles &&
                JSON.parse(this.user)?.roles.length > 0
              ) {
                //// //console.log(JSON.parse(this.user).roles.length);
                this.role.forEach((element: { id: number; roleName: any }) => {
                  if (element.roleName == 'eleve') {
                    this.eleve = true;
                    //// //console.log(this.eleve);
                  }
                  if (this.role.length > 0) {
                    this.role.forEach(
                      (element: { id: number; roleName: any }) => {
                        this.nomrole = element.roleName;
                        this.cohorte = JSON.parse(
                          this.user,
                        ).beneficiaryCohortes[0]?.cohorte.cohorteName;
                        sessionStorage.setItem('nomrole', this.nomrole);
                        switch (element.roleName) {
                          case 'admin': {
                            this.isAdmin = true;
                            break;
                          }
                          case 'eleve': {
                            this.eleve = true;
                            break;
                          }

                          case 'coursera_srudent': {
                            this.coursera_user = true;
                            break;
                          }
                          case 'gestionnaire': {
                            this.isFcc = true;
                            break;
                          }
                          case 'stemd': {
                            this.isStemd = true;
                            break;
                          }
                          case 'board': {
                            this.isBoard = true;
                            break;
                          }
                          case 'suivi': {
                            this.isSEV = true;
                            break;
                          }
                          case 'finance': {
                            this.isFinance = true;
                            break;
                          }
                          case 'etudiant_stemd': {
                            this.isStudentStemd = true;
                            break;
                          }
                          case 'chefetablissement_stemd': {
                            this.isChefEtab = true;
                            break;
                          }
                          case 'mentor': {
                            this.isMentor = true;
                            break;
                          }
                          case 'aipen': {
                            this.isAipen = true;
                            break;
                          }
                          case 'admin-fcc': {
                            this.isAdminFcc = true;
                          }
                        }
                      },
                    );
                    // console.log(
                    //   "le profil de l'apprenant xxxxxx : ",
                    //   this.profil
                    // );
                  }
                });
              }
              $(document).on(
                'click',
                '.layout-menu-button, .layout-mask',
                function () {
                  $('.layout-sidebar').toggleClass('translate');
                  $('.main_container').toggleClass('large');
                  $('.layout-mask').toggleClass('active');
                },
              );
            },
          });
      }
    });
  }

  logout() {
    sessionStorage.clear();

    window.location.href =
      'https://raagnale.force-n.sn/realms/' +
      environment.keycloak.realm +
      '/protocol/openid-connect/logout?client_id=' +
      environment.keycloak.clientId +
      '&post_logout_redirect_uri=' +
      config.redirectURI;
    // console.log('url redirection: ', config.redirectURI);
    // console.log('url redirection: ', environment.keycloak.realm);
    // console.log('url redirection: ', environment.keycloak.clientId);
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  cstBurger() {
    if (!document.body.classList.contains('nav-active'))
      document.body.classList.add('nav-active');
    else document.body.classList.remove('nav-active');
  }
  private checkIsMae(list: any[]): boolean {
    // console.log('je suis dedans : ', list);

    if (!list || list.length === 0) {
      return false;
    }

    const match = list.some((element) => {
      // console.log('la cohorte ', element);
      return element.cohort?.includes('M');
    });

    // console.log('match : ', match);
    return match;
  }
  ngAfterViewInit(): void {
    this.closeSidebarOnMobile();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.closeSidebarOnMobile();
  }

  private closeSidebarOnMobile(): void {
    if (window.innerWidth <= 768) {
      $('.layout-sidebar').addClass('translate');
      $('.main_container').addClass('large');
      $('.layout-mask').removeClass('active');
    }
  }

}
